<template>
  <div
    class="modal fade file-view"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="fileViewLabel"
  >
    <div class="modal-dialog modal-fullscreen" role="document">
      <div class="modal-content">
        <div
          class="modal-header d-flex justify-content-between align-items-center"
        >
          <h4 class="modal-title" id="fileViewLabel">{{ title }}</h4>
          <div
            class="button-container"
            style="display: flex; align-items: center"
          >
            <button
              type="button"
              class="close"
              style="display: flex; align-items: center"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body w-100 h-100">
          <div v-if="!error" class="w-100 h-100">
            <!-- Show image -->
            <div v-if="fileType === 'image'" class="w-100 h-100 text-center">
              <img
                :src="iframeSrc"
                alt="Image"
                class="img-fluid h-100"
                style="object-fit: contain"
              />
            </div>

            <!-- Show PDF -->
            <div v-else-if="fileType === 'pdf'" class="w-100 h-100">
              <object
                :data="iframeSrc"
                type="application/pdf"
                class="w-100 h-100"
              ></object>
            </div>
          </div>

          <h4 v-if="error" class="text-danger text-center">{{ error }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileViewModal",

  props: {
    modalId: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
      default: "View",
    },
    axios: {
      type: Function,
      required: true,
    },
  },
  data: () => {
    return {
      error: null,
      iframeSrc: null,
      pdfLoadError: false,
      fileType: null,
    };
  },
  methods: {
    resetModal() {
      this.iframeSrc = null;
      this.fileType = null;
      this.error = null;
      this.pdfLoadError = false;
    },
    //method to handle image-specific loading
    loadImage(fileData, mimeType) {
      this.iframeSrc = null;
      this.$nextTick(() => {
        this.iframeSrc = `data:${mimeType};base64,${fileData}`;
      });

      this.fileType = "image";
    },

    //method to handle PDF-specific loading
    loadPDF(fileData, mimeType) {
      this.iframeSrc = null;
      this.$nextTick(() => {
        this.iframeSrc = `data:${mimeType};base64,${fileData}`;
      });

      this.fileType = "pdf";
    },
    async loadContent() {
      try {
        const response = await this.axios.get(this.url);
        const mimeType = response.data.mimeType;
        const fileData = response.data.fileData;

        // Check MIME type and handle accordingly
        if (mimeType.startsWith("image/")) {
          this.loadImage(fileData, mimeType); // Handling image
        } else if (mimeType === "application/pdf") {
          this.loadPDF(fileData, mimeType); // Handling PDF
        } else {
          // Handle unknown or unsupported files
          this.error = "Unsupported file type";
        }
        this.error = null; // Clear any previous errors
      } catch (error) {
        this.pdfLoadError = true;
        console.error("Error loading PDF:", error);
        this.error = "Failed to load PDF";
      }
    },
  },
  beforeDestroy() {
    $(`#${this.modalId}`).off("hidden.bs.modal");
  },

  mounted() {
    const modalSelector = `#${this.modalId}`;

    $(modalSelector).on("hidden.bs.modal", () => {
      this.resetModal();
      $(modalSelector).attr("aria-hidden", "true");
    });

    $(modalSelector).on("shown.bs.modal", () => {
      this.resetModal();
      $(modalSelector).attr("aria-hidden", "false");
      this.$nextTick(() => {
        this.loadContent();
      });
    });
  },
};
</script>

<style>
.file-view .modal-content {
  height: 100vh;
}
.file-view .modal-fullscreen {
  width: 100vw;
  max-width: none;
  margin: 0;
}
.file-view .modal-header {
  padding: 9px;
}
.file-view .cst-size {
  font-size: 14px;
  margin-top: 4px;
}
</style>
